"use strict";

function setAdvancedOptions(_ref, _ref2) {
  var origin = _ref.origin;
  var warehouses = _ref2.warehouses;
  var storeId = 76706;
  var warehouseId = warehouses[origin].warehouseId;
  return {
    storeId: storeId,
    warehouseId: warehouseId
  };
}

module.exports = setAdvancedOptions;